import type { DatasetImage } from "@/entities/dataset";

import { useMemo } from "react";

export const useDefectSuggestionsStableDatasetsImage = (
  datasetsImage: DatasetImage[] = []
) => {
  const datasetsImageDependency = datasetsImage
    .map(({ id, data_path, updated_at }) => `${id}_${data_path}_${updated_at}`) // only dataset data used in inference endpoint is enough here
    .join("||");

  const datasetsImageStable = useMemo(() => {
    return datasetsImage;
    // Depend on a content key to avoid reruns caused by array identity churn.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [datasetsImageDependency]);

  return {
    datasetsImageStable,
  };
};
